exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dashboardSubcontractorsGPM-f8bd5{margin-bottom:40px;padding:16px 24px;background-color:#fff}", ""]);

// Exports
exports.locals = {
	"dashboardSubcontractorsGPM": "dashboardSubcontractorsGPM-f8bd5"
};